import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  // Modals
  const [kycUser, setKycUser] = useState(null);
  const [rejectedReason, setRejectedReason] = useState("");
  const [resetUser, setResetUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/users`);
      setUsers(Array.isArray(res.data) ? res.data : (res.data?.Users?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleToggleStatus = async (userId, currentStatus) => {
    if (!window.confirm(`Are you sure you want to ${currentStatus ? "deactivate" : "activate"} this account?`)) return;
    try {
      await axios.post(`${API_BASE_URL}/api/admin/users/${userId}/status`);
      fetchUsers();
    } catch (err) {
      alert("Failed to update user status");
    }
  };

  const handleKycAction = async (userId, action) => {
    try {
      await axios.post(`${API_BASE_URL}/api/admin/users/${userId}/kyc`, {
        action,
        rejectedReason: action === "reject" ? rejectedReason : "",
      });
      setKycUser(null);
      setRejectedReason("");
      fetchUsers();
    } catch (err) {
      alert("Failed to action KYC request");
    }
  };

  const handleResetDemo = async (userId, userName) => {
    if (!window.confirm(`One-Click Demo Reset for ${userName}:\n\nThis will clear all holdings/positions and reset virtual balance to ₹1,00,000. Continue?`)) return;
    try {
      const res = await axios.post(`${API_BASE_URL}/api/admin/users/${userId}/reset-demo`);
      alert(res.data.message);
      fetchUsers();
    } catch (err) {
      alert("Failed to reset demo account");
    }
  };

  const handlePasswordResetSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword || newPassword.length < 6) return alert("Password must be at least 6 characters");
    try {
      const res = await axios.post(`${API_BASE_URL}/api/admin/users/${resetUser._id}/reset-password`, {
        newPassword,
      });
      alert(res.data.message);
      setResetUser(null);
      setNewPassword("");
    } catch (err) {
      alert("Failed to reset password");
    }
  };

  const filteredUsers = users.filter(
    (u) =>
      u.name?.toLowerCase().includes(search.toLowerCase()) ||
      u.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div>
          <h2 style={{ margin: 0, color: "#fff" }}>User & KYC Management</h2>
          <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
            Manage client accounts, verify identity documents, reset demo states, and enforce security policies
          </p>
        </div>

        <input
          type="text"
          placeholder="Search client by name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ padding: "8px 14px", backgroundColor: "#1e222d", border: "1px solid #363c4e", color: "#fff", borderRadius: "6px", width: "260px" }}
        />
      </div>

      <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", overflow: "hidden", border: "1px solid #2a2e39" }}>
        {loading ? (
          <div style={{ padding: "20px", color: "#888" }}>Loading client directory...</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#2a2e39", color: "#b2b5be", textAlign: "left" }}>
                <th style={thStyle}>Client Details</th>
                <th style={thStyle}>Account Status</th>
                <th style={thStyle}>KYC Status</th>
                <th style={thStyle}>Last Login Device & IP</th>
                <th style={thStyle}>Registration Date</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((u) => (
                <tr key={u._id} style={{ borderBottom: "1px solid #2a2e39" }}>
                  <td style={tdStyle}>
                    <div style={{ fontWeight: "bold", color: "#fff" }}>{u.name}</div>
                    <div style={{ fontSize: "11px", color: "#888" }}>{u.email}</div>
                  </td>
                  <td style={tdStyle}>
                    <span
                      style={{
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontSize: "11px",
                        fontWeight: "bold",
                        backgroundColor: u.isActive ? "rgba(76, 175, 80, 0.15)" : "rgba(239, 83, 80, 0.15)",
                        color: u.isActive ? "#4caf50" : "#ef5350",
                      }}
                    >
                      {u.isActive ? "ACTIVE" : "DEACTIVATED"}
                    </span>
                  </td>
                  <td style={tdStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span
                        style={{
                          padding: "2px 8px",
                          borderRadius: "10px",
                          fontSize: "11px",
                          fontWeight: "bold",
                          backgroundColor:
                            u.kycStatus === "verified"
                              ? "rgba(76, 175, 80, 0.15)"
                              : u.kycStatus === "pending"
                              ? "rgba(255, 152, 0, 0.15)"
                              : "rgba(158, 158, 158, 0.15)",
                          color:
                            u.kycStatus === "verified"
                              ? "#4caf50"
                              : u.kycStatus === "pending"
                              ? "#ff9800"
                              : "#9e9e9e",
                        }}
                      >
                        {u.kycStatus?.toUpperCase()}
                      </span>
                      {u.kycStatus === "pending" && (
                        <button onClick={() => setKycUser(u)} style={smallActionBtn}>
                          Review KYC
                        </button>
                      )}
                    </div>
                  </td>
                  <td style={{ ...tdStyle, fontSize: "11px", color: "#888" }}>
                    <div>IP: {u.lastIp || "N/A"}</div>
                    <div>Agent: {u.lastUserAgent ? u.lastUserAgent.substring(0, 30) + "..." : "N/A"}</div>
                  </td>
                  <td style={tdStyle}>{new Date(u.createdAt).toLocaleDateString()}</td>
                  <td style={tdStyle}>
                    <div style={{ display: "flex", gap: "6px" }}>
                      <button onClick={() => handleToggleStatus(u._id, u.isActive)} style={smallBtnStyle}>
                        {u.isActive ? "Deactivate" : "Activate"}
                      </button>
                      <button onClick={() => setResetUser(u)} style={smallBtnStyle}>
                        🔑 Password
                      </button>
                      <button onClick={() => handleResetDemo(u._id, u.name)} style={smallResetBtn}>
                        🔄 Reset Demo
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* KYC Review Modal */}
      {kycUser && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0, color: "#fff" }}>Review Client KYC: {kycUser.name}</h3>
            <div style={{ backgroundColor: "#1e222d", padding: "12px", borderRadius: "6px", marginBottom: "16px", fontSize: "13px" }}>
              <div><strong>PAN Number:</strong> {kycUser.kycDetails?.pan || "N/A"}</div>
              <div><strong>Aadhaar Number:</strong> {kycUser.kycDetails?.aadhaar || "N/A"}</div>
              <div><strong>Address:</strong> {kycUser.kycDetails?.address || "N/A"}</div>
              <div><strong>Submitted At:</strong> {kycUser.kycDetails?.submittedAt ? new Date(kycUser.kycDetails.submittedAt).toLocaleString() : "N/A"}</div>
            </div>

            <div style={{ marginBottom: "14px" }}>
              <label style={labelStyle}>Rejection Reason (If rejecting)</label>
              <input
                type="text"
                value={rejectedReason}
                onChange={(e) => setRejectedReason(e.target.value)}
                placeholder="e.g. Invalid PAN card formatting"
                style={inputStyle}
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button onClick={() => setKycUser(null)} style={cancelBtnStyle}>Cancel</button>
              <button onClick={() => handleKycAction(kycUser._id, "reject")} style={rejectBtnStyle}>Reject KYC</button>
              <button onClick={() => handleKycAction(kycUser._id, "approve")} style={approveBtnStyle}>Approve KYC</button>
            </div>
          </div>
        </div>
      )}

      {/* Reset Password Modal */}
      {resetUser && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0, color: "#fff" }}>Reset Password: {resetUser.name}</h3>
            <form onSubmit={handlePasswordResetSubmit}>
              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>New Password</label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Min 6 characters"
                  required
                  minLength={6}
                  style={inputStyle}
                />
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button type="button" onClick={() => setResetUser(null)} style={cancelBtnStyle}>Cancel</button>
                <button type="submit" style={btnStyle}>Reset Password</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const thStyle = { padding: "12px", fontSize: "12px", textTransform: "uppercase" };
const tdStyle = { padding: "12px", color: "#d1d4dc" };

const btnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2962ff",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
};

const smallBtnStyle = {
  padding: "4px 8px",
  backgroundColor: "#2a2e39",
  color: "#b2b5be",
  border: "1px solid #363c4e",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "11px",
};

const smallActionBtn = {
  padding: "2px 8px",
  backgroundColor: "#2962ff",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "11px",
};

const smallResetBtn = {
  padding: "4px 8px",
  backgroundColor: "rgba(255, 152, 0, 0.2)",
  color: "#ffb74d",
  border: "1px solid #ffb74d",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "11px",
};

const approveBtnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
};

const rejectBtnStyle = {
  padding: "8px 16px",
  backgroundColor: "#c62828",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
};

const cancelBtnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2a2e39",
  color: "#fff",
  border: "1px solid #363c4e",
  borderRadius: "4px",
  cursor: "pointer",
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const modalContentStyle = {
  backgroundColor: "#2a2e39",
  padding: "24px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "460px",
  color: "#fff",
};

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: 500,
  marginBottom: "6px",
  color: "#d1d4dc",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #434651",
  backgroundColor: "#1e222d",
  color: "#fff",
  fontSize: "14px",
  boxSizing: "border-box",
};

export default UserManagement;
